import { FormGroup } from '@angular/forms';
export function ValidatorCaracterEmail(formGroup: FormGroup) {
  const specialChars = /[`!#$%^&*()+\=\[\]{};':"\\|,<>\/?~]/;
  return specialChars.test(formGroup.get('email')?.value) ? { invalidEmail: true } : null;
}
